export const insertSeatsToRows = (
  rebooking: boolean | undefined,
  rebookOffers: any,
  rows: any[],
  inboundMessage: string,
) => {
  if (rebooking) {
    const outboundSeats =
      rebookOffers?.seatRows?.outboundRows?.length > 0 ? [...rebookOffers.seatRows.outboundRows] : [];

    rows.splice(1, 0, rebookOffers.outbound, ...outboundSeats);

    const index = rows.findIndex(row => row.label === inboundMessage);
    if (Object.values(rebookOffers.inbound).length > 0) {
      if (index !== -1) {
        const inboundSeats =
          rebookOffers?.seatRows?.inboundRows?.length > 0 ? [...rebookOffers.seatRows.inboundRows] : [];

        rows.splice(index + 1, 0, rebookOffers.inbound, ...inboundSeats);
      }
    }
  }
};
